import { useAppSelector } from './redux/useApp';
import { Session } from '../modules/session';

/**
 * Typed hook to access the full session from Redux.
 *
 * Use this instead of `useSelector(s => s.session)` or extracting
 * individual booleans. Combine with the helper functions exported
 * from `modules/session` (isReadWrite, isOwner, isReadOnly, etc.)
 * so that permission checks stay future-proof:
 *
 * @example
 * ```ts
 * import { useSession } from '../../hooks';
 * import { isReadWrite } from '../../modules/session';
 *
 * const session = useSession();
 * const canEdit = session.isSystemAdmin && isReadWrite(session);
 * ```
 */
export const useSession = (): Session => {
  return useAppSelector((state) => state.session);
};
